<template>
  <div class="flex flex-col overflow-hidden">
    <div class="flex flex-col gap-2">
      <SearchBar @input="query = $event" />
    </div>
    <slot name="list" :filteredItems="filteredItems" :query="query">
      <ScrollableList :items="filteredItems" :isLoading="isLoading">
        <template #item>
          <slot name="item" />
        </template>
        <template #skeleton>
          <slot name="skeleton" />
        </template>
      </ScrollableList>
    </slot>
  </div>
</template>

<script setup>
import { SearchBar } from "@/Components/Search";
import { ScrollableList } from "@/Components/List";
import { computed, ref } from "vue";

const props = defineProps({
  items: { type: Array, default: () => [] },
  field: { type: String, default: "name" },
  isLoading: { type: Boolean, default: false },
});

const query = ref("");

const filteredItems = computed(() => {
  if (props.isLoading) {
    return;
  }
  const parsedQuery = query.value.trim().toLowerCase();
  if (!parsedQuery) {
    return props.items;
  }
  return Object.values(props.items).filter((item) => {
    return item[props.field].trim().toLowerCase().includes(parsedQuery);
  });
});
</script>
